<script>
import { defineComponent } from 'vue'
import { useOrganizationStore } from '@/stores/organization.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwButton from '@/components/generic/tw-button.vue'
import TwCard from '@/components/generic/tw-card.vue'

export default defineComponent({
  name: 'OrganizationWebconnexIntegrationPage',
  components: { TwCard, TwButton, TwListGroupItem, TwListGroup, TwLoadingSpinner },
  props: {
    organizationId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      LoadingFetchingWebconnexApiKeys: false,
      WebconnexApiKeys: [],
      ShowMessage: true,
    }
  },
  computed: {
    organization() {
      return useOrganizationStore().getItemById(this.organizationId)
    },
    connectedRedPodiumAccount() {
      return this.WebconnexApiKeys.find(item => item.id === parseInt(this.$route.query.success))
    }
  },
  mounted() {
    useOrganizationStore().fetchItemById(this.organizationId)
    this.fetchWebconnexApiKeys()
  },
  methods: {
    async fetchWebconnexApiKeys() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingWebconnexApiKeys = true
        this.WebconnexApiKeys = await useOrganizationStore().fetchWebconnexApiKeys(this.organizationId)
        this.LoadingFetchingWebconnexApiKeys = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingWebconnexApiKeys = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async deleteWebConnexApiKey(webconnexApiKey) {
      if (!confirm(`Are you sure you want to delete the RedPodium Integration "${webconnexApiKey.account_name}"?`)) return
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingWebconnexApiKeys = true
        await useOrganizationStore().deleteWebconnexApiKey(this.organizationId, webconnexApiKey.id)
        this.WebconnexApiKeys = this.WebconnexApiKeys.filter(item => item.id !== webconnexApiKey.id)
        this.LoadingFetchingWebconnexApiKeys = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingWebconnexApiKeys = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
})
</script>

<template>
  <div>
    <h2>Organization Webconnex Integration</h2>
    <tw-card v-if="$route.query.success && ShowMessage" class="bg-green-200 text-green-900 text-center text-xl w-1/2 mx-auto mt-20 mb-10">
      <tw-button variant="link" icon="times" class="float-right" @click="ShowMessage = false" />
      Success! Your <span v-if="connectedRedPodiumAccount" class="font-bold">
        {{ connectedRedPodiumAccount.account_name }}
      </span> RedPodium account is now connected.
    </tw-card>
    <tw-card v-if="$route.query.error && ShowMessage" class="bg-red-200 text-red-900 text-center text-xl w-1/2 mx-auto mt-20 mb-10">
      <tw-button variant="link" icon="times" class="float-right" @click="ShowMessage = false" />
      Error! There was an error connecting your RedPodium account. Please try again.
    </tw-card>

    <tw-loading-spinner v-if="LoadingFetchingWebconnexApiKeys">
      Fetching RedPodium Integrations...
    </tw-loading-spinner>
    <div v-if="!LoadingFetchingWebconnexApiKeys && WebconnexApiKeys.length > 0">
      <tw-list-group class="mt-10">
        <tw-list-group-item v-for="webconnexApiKey in WebconnexApiKeys" :key="'webconnex-api-key-' + webconnexApiKey.id" class="bg-gray-50">
          <div>
            {{ webconnexApiKey.account_name }} - RedPodium Account ID: {{ webconnexApiKey.account_id }}
          </div>
          <div class="mt-2 flex flex-row-reverse">
            <tw-button variant="danger" size="sm" @click="deleteWebConnexApiKey(webconnexApiKey)">
              Delete
            </tw-button>
          </div>
        </tw-list-group-item>
      </tw-list-group>
    </div>
    <div v-if="!LoadingFetchingWebconnexApiKeys && WebconnexApiKeys.length === 0" class="flex flex-col gap-10">
      <div class="mt-10 text-center text-gray-600">
        No RedPodium Integrations found for this organization.
      </div>
      <tw-button variant="secondary" href="/integrations/webconnex/oauth">
        Connect To RedPodium Account
      </tw-button>
    </div>
  </div>
</template>

<style scoped>

</style>
